import { Button, Icon, Modal, Typography } from "@/components/atoms";

interface DowngradeSuccessModalProps {
  open: boolean;
  onClose: () => void;
  operatorName?: string;
}

export const DowngradeSuccessModal = ({ open, onClose, operatorName = "Operator" }: DowngradeSuccessModalProps) => {
  const handleBackToSubscriptions = () => {
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} className="w-[85vw] md:w-[420px] lg:w-[420px]">
      <div className="flex flex-col items-center gap-6">
        {/* Thumbs Up Icon */}
        <div className="flex h-[80px] w-[80px] items-center justify-center rounded-full bg-primary-light">
          <Icon size="xl" name="Like1" variant="Bold" className="text-primary" />
        </div>

        {/* Title and Description */}
        <div className="flex flex-col gap-4 text-center text-neutral-dark-gray">
          <Typography variant="h2">Your plan has been changed. ✅</Typography>
          <Typography variant="paragraph">
            Your subscription has been successfully downgraded. Your {operatorName} account is still active, but with fewer features than
            before.
          </Typography>
        </div>

        {/* Action Button */}
        <Button type="button" size="lg" variant="primary" className="w-full" onClick={handleBackToSubscriptions}>
          Back to Subscriptions
        </Button>
      </div>
    </Modal>
  );
};
